import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const containerConfig = {
transform(props) {
  const { size = "lg", ...rest } = props;
  const sizeMap = {
    sm: "container-sm",
    md: "container-md",
    lg: "container-lg",
    xl: "container-xl",
    full: "[100%]"
  };
  return {
    maxWidth: sizeMap[size],
    marginInline: "auto",
    paddingInline: "4",
    ...rest
  };
},
defaultValues:{size:'lg'}}

export const getContainerStyle = (styles = {}) => {
  const _styles = getPatternStyles(containerConfig, styles)
  return containerConfig.transform(_styles, patternFns)
}

export const container = (styles) => css(getContainerStyle(styles))
container.raw = getContainerStyle